import { arrayContains } from 'Utils';
import Actions from 'Redux/Actions';
import { TRootState } from 'Redux/Reducers';

export const isMauDauWauLoading = (state: TRootState) =>
  arrayContains(state.user.openRequests, [
    Actions.findMauDauWauRequest.type,
  ]);



